import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function updateTreeValidity(group: UntypedFormGroup | UntypedFormArray): void {
    const controlKeys = Object.keys(group.controls);

    for (let i = 0; i < controlKeys.length; i++) {
        const key = controlKeys[i];
        const abstractControl = (group.controls as { [key: string]: AbstractControl })[key] as AbstractControl;

        if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray) {
            updateTreeValidity(abstractControl);
        } else {
            abstractControl.updateValueAndValidity();
        }
    }
}
